import React, { useState, useEffect } from "react";

export function useNote(type: string, index: number) {
  const [showNote, setShowNote] = useState<boolean>(() => {
    const saved = localStorage.getItem(`${type}_showNote_${index}`);
    return saved !== null ? JSON.parse(saved) : false;
  });
  const [note, setNote] = useState<string>(() => {
    return (localStorage.getItem(`${type}_note_${index}`) || "").slice(0, 25);
  });

  useEffect(() => {
    localStorage.setItem(`${type}_showNote_${index}`, JSON.stringify(showNote));
  }, [showNote, index, type]);

  useEffect(() => {
    localStorage.setItem(`${type}_note_${index}`, note);
  }, [note, index, type]);

  return { showNote, setShowNote, note, setNote };
}

interface TheNoteProps {
  showNote: boolean;
  note: string;
  setNote: (note: string) => void;
}

export function TheNote({ showNote, note, setNote }: TheNoteProps) {
  return (
    <div className={`the-note ${showNote ? "show" : ""}`}>
      <input
        type="text"
        value={note}
        onChange={(e) => setNote(e.target.value.slice(0, 25))}
        maxLength={25}
        placeholder="Note..."
        size={Math.max((note || "").length, 6)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.currentTarget.blur();
          }
        }}
      />
    </div>
  );
}

interface TheNoteToggleButtonProps {
  showNote: boolean;
  setShowNote: (showNote: boolean) => void;
}

export function TheNoteToggleButton({ showNote, setShowNote }: TheNoteToggleButtonProps) {
  return (
    <button
      type="button"
      className={`btn ${showNote ? "btn-primary" : "btn-outline-primary"
        } btn-sm rounded-pill d-flex align-items-center justify-content-center p-0`}
      style={{ width: "36px", height: "36px", flexShrink: 0 }}
      onClick={() => setShowNote(!showNote)}
      title="Toggle note"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    </button>
  );
}
